import React from 'react';
import './MobileTopBar.css';
import rdvBallImg from '../../assets/rdv-logoBall.png';

/**
 * Slim fixed top bar shown only in the mobile shell (AuthenticatedLayout
 * ≤768px). Hosts the hamburger that opens the Sidebar drawer.
 */
const MobileTopBar = ({ onMenuClick, title }) => (
  <header className='mobile-top-bar'>
    <button
      className='mobile-top-bar__menu'
      onClick={onMenuClick}
      aria-label='Open menu'
    >
      <i className='fas fa-bars'></i>
    </button>
    <div className='mobile-top-bar__brand'>
      <img src={rdvBallImg} alt='RDV' className='mobile-top-bar__logo' />
      {title ? <span className='mobile-top-bar__title'>{title}</span> : null}
    </div>
    {/* Balances the menu button so the brand sits centred, not offset right. */}
    <span className='mobile-top-bar__spacer' aria-hidden='true' />
  </header>
);

export default MobileTopBar;
